export function setItem(name,item){
  localStorage.setItem(name, item);
}

export function getItem(name){
  return localStorage.getItem(name);
}

export function removeItem(name){
  localStorage.removeItem(name);
}
